export default {
	security: {
		securityBind: "سیکیورٹی بائنڈ",
		securitySettings: "سیکیورٹی سیٹنگز",
		level: "درمیانہ",
		confirm: "تصدیق کریں",
		submitting: "جمع کیا جا رہا ہے...",
		add: "شامل کریں",
		change: "تبدیل کریں",
		success: "کامیابی سے اپڈیٹ ہو گیا",
		select: "منتخب کریں",

		birthday: "رابطہ سالگرہ",
		birthdayDesc: "آسان رابطے کے لیے رابطہ سالگرہ بائنڈ کریں۔ آپ کی ذاتی معلومات محفوظ رہیں گی۔",
		month: "مہینہ",
		day: "دن",
		year: "سال",
		birthdayRequired: "سالگرہ ضروری ہے۔",
		invalidBirthday: "غلط سالگرہ۔",
		invalidMonth: "غلط مہینہ۔",
		invalidDay: "غلط دن۔",
		invalidYear: "غلط سال۔",
		updateBirthdayFail: "سالگرہ اپڈیٹ کرنے میں ناکام",
		birthdayVerify: "سالگرہ بائنڈ تصدیق",
		birthdayVerifyDesc: "اپنے اکاؤنٹ کی سیکیورٹی بہتر بنانے کے لیے اپنی سالگرہ بائنڈ کریں۔",

		email: "رابطہ ای میل",
		emailDesc: "اکاؤنٹ سیکیورٹی کے لیے ای میل۔ صرف آپ ہی اسے بائنڈ کر سکتے ہیں۔",
		emailRequired: "ای میل ضروری ہے۔",
		emailInvalid: "غلط ای میل ایڈریس۔",
		updateEmailFail: "ای میل اپڈیٹ کرنے میں ناکام",
		emailVerify: "ای میل بائنڈ تصدیق",
		emailVerifyDesc: "اپنے اکاؤنٹ کی سیکیورٹی بہتر بنانے کے لیے اپنے ای میل ایڈریس کی تصدیق کریں۔",

		phone: "فون نمبر",
		bindPhone: "فون نمبر بائنڈ کریں",
		phoneDesc: "اکاؤنٹ سیکیورٹی کے لیے فون نمبر۔ صرف آپ ہی اسے بائنڈ کر سکتے ہیں۔",
		phoneRequired: "فون نمبر ضروری ہے۔",
		phoneUsed: "براہ کرم مختلف فون نمبر استعمال کریں۔",
		updatePhoneFail: "فون نمبر اپڈیٹ کرنے میں ناکام",
		noCode: "کوڈ موصول نہیں ہوا؟",
		smsHelp: "اگر آپ نے کئی بار کوشش کی ہے لیکن پھر بھی تصدیقی کوڈ موصول نہیں ہوا۔",
		smsTips1: "1. چیک کریں کہ جو موبائل نمبر آپ نے درج کیا ہے وہ درست ہے۔",
		smsTips2: "2. چیک کریں کہ آپ کا موبائل نمبر پرانا تو نہیں ہو گیا۔",
		smsTips3: "3. چیک کریں کہ پیغام SMS باکس میں تو نہیں ہے۔",
		smsTips4: "4. پیغام چند منٹ تاخیر سے آ سکتا ہے۔",
		phoneVerify: "فون نمبر بائنڈ تصدیق",
		phoneVerifyDesc: "اپنے اکاؤنٹ کی سیکیورٹی بہتر بنانے کے لیے اپنے فون نمبر کی تصدیق کریں۔",

		setPassword: "پاس ورڈ سیٹ کریں",
		passwordDesc: "اپنا سائن اِن پاس ورڈ سیٹ کریں۔",
		clickSelectBirthday: "سالگرہ منتخب کرنے کے لیے کلک کریں",
		selectBirthday: "سالگرہ منتخب کریں",
		confirm: "تصدیق کریں",
		cancel: "منسوخ کریں",
		withdrawPassword: "رقم نکالنے کا پاس ورڈ",
		withdrawpasswordDesc: "رقم نکالنے کے لیے اپنا پاس ورڈ سیٹ کریں۔",
		set: "سیٹ کریں",
	},

	contactPhone: {
		title: "فون نمبر تبدیل کریں",
		titleMobile: "تبدیل کریں",
		description: "آسان مواصلات کے لیے رابطہ نمبر شامل کریں۔ آپ کی ذاتی معلومات محفوظ رہے گی۔",
		label: "رابطہ فون نمبر",
		confirm: "تصدیق کریں",
		submitting: "جمع ہو رہا ہے...",
		required: "فون نمبر درکار ہے",
		invalid: "فون نمبر غلط ہے",
		success: "فون نمبر کامیابی سے اپ ڈیٹ ہو گیا!",
		updateFailed: "اپ ڈیٹ ناکام",
		tryAgain: "اپ ڈیٹ ناکام ہوا، بعد میں دوبارہ کوشش کریں",
		verifyTitleMobile: "فون نمبر کی تصدیق",
		titleMobile: "فون لنک کریں",
		changeTitleMobile: "فون تبدیل کریں",
		securityTip: "اکاؤنٹ کی حفاظت کے لیے فون نمبر۔ صرف آپ ہی اسے لنک کر سکتے ہیں۔",
		placeholder: "فون نمبر",
		noCodeReceived: "کوڈ موصول نہیں ہوا؟",
		codeDescription: "نیچے دی گئی اپنی رابطہ کی تفصیلات پر بھیجا گیا 6 ہندسوں کا تصدیقی کوڈ درج کریں:",
		resendIn: "{countdown} سیکنڈ میں دوبارہ بھیجیں",
		resend: "دوبارہ بھیجیں",
		submitting: "جمع ہو رہا ہے...",
		confirm: "تصدیق کریں",
		invalidCode: "براہ کرم ایک درست 6 ہندسوں کا کوڈ درج کریں",
		required: "فون نمبر درکار ہے",
		invalid: "براہ کرم ایک درست فون نمبر درج کریں",
		success: "کامیابی سے اپ ڈیٹ ہو گیا",
		updateFailed: "اپ ڈیٹ ناکام ہو گیا",
		tryAgain: "براہ کرم کچھ دیر بعد دوبارہ کوشش کریں"
	},

	contactEmail: {
		title: "ای میل تبدیل کریں",
		titleMobile: "تبدیل کریں",
		description: "آسان مواصلات کے لیے رابطہ ای میل شامل کریں۔ آپ کی ذاتی معلومات محفوظ رہے گی۔",
		label: "رابطہ ای میل",
		placeholder: "ای میل",
		confirm: "تصدیق کریں",
		submitting: "جمع ہو رہا ہے...",
		required: "ای میل خالی نہیں ہو سکتا",
		invalid: "براہ مہربانی درست ای میل درج کریں",
		success: "ای میل کامیابی سے اپ ڈیٹ ہو گیا!",
		updateFailed: "اپ ڈیٹ ناکام",
		tryAgain: "اپ ڈیٹ ناکام ہوا، بعد میں دوبارہ کوشش کریں",
		verifyTitleMobile: "ای میل کی تصدیق",
		titleMobile: "ای میل لنک کریں",
		changeTitleMobile: "ای میل تبدیل کریں",
		securityTip: "اکاؤنٹ کی حفاظت کے لیے ای میل۔ صرف آپ ہی اسے لنک کر سکتے ہیں۔",
		noCodeReceived: "کوڈ موصول نہیں ہوا؟",
		codeDescription: "نیچے دی گئی اپنی رابطہ کی تفصیلات پر بھیجا گیا 6 ہندسوں کا تصدیقی کوڈ درج کریں:",
		resendIn: "{countdown} سیکنڈ میں دوبارہ بھیجیں",
		resend: "دوبارہ بھیجیں",
		submitting: "جمع ہو رہا ہے...",
		confirm: "تصدیق کریں",
		invalidCode: "براہ کرم ایک درست 6 ہندسوں کا کوڈ درج کریں",
		required: "ای میل درکار ہے",
		invalid: "براہ کرم ایک درست ای میل ایڈریس درج کریں",
		success: "کامیابی سے اپ ڈیٹ ہو گیا",
		updateFailed: "اپ ڈیٹ ناکام ہو گیا",
		tryAgain: "براہ کرم کچھ دیر بعد دوبارہ کوشش کریں"
	},

	accountInfo: {
		profileInfo: "پروفائل کی معلومات",
		contactInfo: "رابطہ کی معلومات",
		privacy: "رازداری",
		contactEmail: "رابطہ ای میل",
		contactPhone: "رابطہ فون نمبر",
		addEmailDesc: "آسان مواصلات کے لیے رابطہ ای میل شامل کریں۔ آپ کی ذاتی معلومات محفوظ رہے گی۔",
		addPhoneDesc: "آسان مواصلات کے لیے رابطہ فون نمبر شامل کریں۔ آپ کی ذاتی معلومات محفوظ رہے گی۔",
		hideUsername: "عوامی فہرستوں سے میرا یوزر نیم چھپائیں",
		add: "شامل کریں",
		change: "تبدیل کریں",
		idLabel: "ID: ",
		vip: "VIP ",
		player: "کھلاڑی",
		copied: "کاپی ہو گیا!",
		hideSuccess: "یوزر نیم کامیابی سے چھپا دیا گیا",
		showSuccess: "یوزر نیم کامیابی سے دکھایا گیا",
		operationFailed: "آپریشن ناکام",
		editProfile: "پروفائل تبدیل کریں",
		contactInfo: "رابطہ کی معلومات",
		contactEmail: "رابطہ ای میل",
		emailTip: "آسان گفتگو کے لیے رابطہ ای میل شامل کریں۔ آپ کی ذاتی معلومات محفوظ رہے گی۔",
		change: "تبدیل کریں",
		addEmail: "ای میل شامل کریں",
		contactPhone: "رابطہ فون نمبر",
		phoneTip: "محفوظ اکاؤنٹ کی تصدیق کے لیے اپنا فون نمبر شامل کریں۔",
		addPhone: "فون نمبر شامل کریں",
		birthdayBind: "تاریخ پیدائش کی تصدیق",
		birthdayTip: "اپنے اکاؤنٹ کی حفاظت کو بہتر بنانے کے لیے اپنی تاریخ پیدائش منسلک کریں۔",
		addBirthday: "تاریخ پیدائش شامل کریں",
		personalInfo: "ذاتی معلومات",
		personalTip: "مزید سروسز حاصل کرنے کے لیے اپنی شناخت کی تصدیق کریں۔ آپ کا ڈیٹا محفوظ ہے۔",
		verifyNow: "ابھی تصدیق کریں",
		hideUsernameTip: "فعال ہونے پر، دوسرے صارفین عوامی فہرستوں میں آپ کا صارف نام نہیں دیکھ سکیں گے۔",
	},

	kyc: {
		title: "شناخت کی تصدیق",
		verifyIdentity: "اپنی شناخت کی تصدیق کریں",
		completeDesc: "اپنے اکاؤنٹ کو محفوظ رکھنے اور تمام فیچرز کھولنے کے لیے شناخت کی تصدیق مکمل کریں۔",
		failed: "تصدیق ناکام۔ براہ کرم دوبارہ کوشش کریں۔",
		reVerify: "دوبارہ تصدیق کریں",
		checkYouOut: "آئیے آپ کی شناخت کی تصدیق کریں",
		prepareDoc: "اپنا دستاویز تیار کریں",
		prepareDocDesc: "ایک درست شناختی دستاویز تیار رکھیں۔",
		useSmartphone: "اسمارٹ فون استعمال کریں",
		useSmartphoneDesc: "تصدیق مکمل کرنے کے لیے آپ کو اسمارٹ فون کی ضرورت ہوگی۔",
		scanQr: "کیو آر کوڈ اسکین کریں",
		scanQrDesc: "موبائل پر جاری رکھنے کے لیے اپنے فون سے کیو آر کوڈ اسکین کریں۔",
		noSmartphone: "اسمارٹ فون نہیں ہے؟",
		completeOnMobile: "موبائل پر مکمل کریں"
	},

	verify: {
		title: "تصدیق",
		personalVerification: "ذاتی تصدیق",
		weak: "کمزور",
		level1: "درجہ 1",
		personalInfo: "ذاتی معلومات",
		personalInfoDesc: "اپنے اکاؤنٹ کی سیکیورٹی بہتر بنانے کے لیے اپنی ذاتی معلومات مکمل کریں۔",
		verifyNow: "ابھی تصدیق کریں",
		level2: "درجہ 2",
		kycVerification: "KYC تصدیق",
		kycDesc: "زیادہ حدود اور مکمل رسائی کھولنے کے لیے KYC تصدیق مکمل کریں۔",
		docTip: "جمع کروانے سے پہلے یقینی بنائیں کہ آپ کے دستاویزات واضح اور درست ہیں۔"
	},

	personalInfo: {
		verify: "تصدیق",
		completeInfo: "اپنی معلومات مکمل کریں",
		completeInfoDesc: "تصدیق مکمل کرنے کے لیے اپنی ذاتی تفصیلات درج کریں۔",
		firstName: "پہلا نام",
		paternalSurname: "والد کا نام",
		maternalSurname: "والدہ کا نام",
		contactNumber: "رابطہ نمبر",
		phoneUsed: "یہ فون نمبر پہلے سے استعمال میں ہے۔",
		contactEmail: "رابطہ ای میل",
		invalidEmail: "غلط ای میل ایڈریس۔",
		detailedAddress: "تفصیلی پتہ",
		city: "شہر",
		street: "گلی",
		neighborhood: "محلہ",
		houseNumber: "مکان نمبر",
		postalCode: "پوسٹل کوڈ",
		save: "محفوظ کریں",
		male: "مرد",
		female: "عورت"
	},

	withdrawPassword: {
		changeTitle: "نکالنے کا پاس ورڈ تبدیل کریں",
		setTitle: "نکالنے کا پاس ورڈ سیٹ کریں",
		changeDesc: "اپنا پرانا پاس ورڈ درج کریں اور نیا نکالنے کا پاس ورڈ سیٹ کریں۔",
		setDesc: "اپنی رقم کی حفاظت کے لیے نکالنے کا پاس ورڈ سیٹ کریں۔",
		oldPlaceholder: "پرانا نکالنے کا پاس ورڈ",
		newPlaceholder: "نیا نکالنے کا پاس ورڈ",
		confirmPlaceholder: "نکالنے کے پاس ورڈ کی تصدیق کریں"
	},

	contactBirthday: {
		title: "رابطہ سالگرہ",
		desc: "آسان رابطے کے لیے رابطہ سالگرہ بائنڈ کریں۔ آپ کی ذاتی معلومات محفوظ رہیں گی۔",
		label: "رابطہ سالگرہ",
		invalid: "غلط سالگرہ۔"
	},

	changePassword: {
		title: "پاس ورڈ تبدیل کریں",
		expiredDesc: "آپ کا پاس ورڈ ختم ہو گیا ہے۔ جاری رکھنے کے لیے نیا پاس ورڈ سیٹ کریں۔",
		verifyOldDesc: "اپنا پرانا پاس ورڈ درج کریں اور نیا سیٹ کریں۔",
		passwordPlaceholder: "پرانا پاس ورڈ",
		newPlaceholder: "نیا پاس ورڈ",
		confirmPlaceholder: "نئے پاس ورڈ کی تصدیق کریں",
		lengthError: "پاس ورڈ 6 سے 30 حروف کا ہونا چاہیے۔",
		sameAsOld: "نیا پاس ورڈ پرانے جیسا نہیں ہو سکتا۔",
		confirmRequired: "براہ کرم اپنے نئے پاس ورڈ کی تصدیق کریں۔",
		notMatch: "پاس ورڈ مماثل نہیں ہیں۔",
		success: "پاس ورڈ کامیابی سے تبدیل ہو گیا",
		failed: "پاس ورڈ تبدیل کرنے میں ناکام"
	},

	settingsNav: {
		title: "ترتیبات",
		accountInfo: "اکاؤنٹ کی معلومات",
		security: "سیکیورٹی"
	},

	verificationBirthday: {
		title: "تاریخ پیدائش",
		securityTip: "اکاؤنٹ کی سیکیورٹی کے لیے تاریخ پیدائش۔ اسے صرف آپ ہی منسلک کر سکتے ہیں۔",
		clickSelectBirthday: "تاریخ پیدائش منتخب کرنے کے لیے کلک کریں",
		invalidBirthday: "غلط تاریخ پیدائش",
		submitting: "جمع ہو رہا ہے...",
		confirm: "تصدیق کریں",
		cancel: "منسوخ کریں",
		selectBirthday: "تاریخ پیدائش منتخب کریں",
		birthdayRequired: "تاریخ پیدائش درکار ہے",
		updateBirthdayFail: "تاریخ پیدائش اپ ڈیٹ کرنے میں ناکامی",
		success: "کامیابی سے اپ ڈیٹ ہو گیا"
	}
};